import { alpha } from '@mui/material/styles'

import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  combo: {
    display: 'flex',
    minHeight: 91,
    alignItems: 'flex-end',

    '& .MuiFormControl-root': {
      '& + .MuiFormControl-root': {
        marginLeft: -1,
        '& input': {
          borderLeftColor: alpha(theme.palette.neutral.lighter, 0.2),
        },
      },
    },

    '&.singleHelperText': {
      position: 'relative',
      marginBottom: theme.spacing(3),
      paddingBottom: theme.spacing(3),

      '& .MuiFormHelperText-root': {
        position: 'absolute',
        bottom: 0,
      },

      '& .MuiFormControl-root': {
        '& + .MuiFormControl-root': {
          '&:after': {
            top: '67%',
          },
        },
      },
    },
  },
}))

export default useStyles
